import { FaWhatsapp } from "react-icons/fa";

export default function WhatsAppFloating() {
  return (
    <a
      href="https://wa.me/919538577199?text=Hello%2C%20I%20would%20like%20to%20contact%20Credible%20Technologies%20regarding%20laptops."
      target="_blank"
      rel="noopener noreferrer"
      className=" fixed bottom-4 sm:bottom-6 right-4 sm:right-6 md:right-6 bg-green-500 hover:bg-green-600 text-white
        p-3 sm:p-4 rounded-full shadow-xl flex items-center justify-center z-50 animate-bounce transition-all"
    >
      <FaWhatsapp className="w-5 h-5 sm:w-6 sm:h-6 md:w-6 md:h-6" />
    </a>
  );
}
